import * as React from 'react';
import { TextDirection } from './textDirection';
import { useMsgText } from './hooks';
import { useAppState } from '../core/redux/hooks';


interface Props extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  forceDirection?: TextDirection;
  /**
   * The translation key to lookup for the input's placeholder value
   */
  placeholderTranslation: string;

  /**
   * Fallback text to be used for the translated placeholder string can't be found
   */
  placeholderDefault?: string;
}


/**
 * LocalTextArea: a component that renders a textarea with explicitly set text direction (either as provided by the user
 * or otherwise sourced from app state).
 *
 * PureComponent: true
 * Redux Connected: false
 */
const LocalTextArea: React.FC<Props> = props => {
  const { placeholderTranslation, placeholderDefault, ...rest } = props;

  const translation = useMsgText(placeholderTranslation, placeholderDefault);

  const dir = useAppState(state => state.locale.textDirection);

  return (
    <textarea {...rest} dir={dir} placeholder={translation}>
      {props.children}
    </textarea>
  );
};

export default LocalTextArea;